import { SessionUnauthorized, SessionAuthorized } from 'types/state';

export const createSessionUnauthorized = (): SessionUnauthorized => ({
  type: 'UNAUTHORIZED'
});

export const createSessionAuthorized = (): SessionAuthorized => ({
  type: 'AUTHORIZED'
});
